import { useQuery } from 'react-query';
import { AssessmentFilters, AssessmentListResponse } from './assessmentTypes';
import { getAssesmentList } from './assessmentService';

type Props<M> = {
    filters: AssessmentFilters;
    onError?: (error: Error) => void;
    onSuccess?: (data: AssessmentListResponse) => void;
    mapper?: (
        data?: AssessmentListResponse
    ) => M | AssessmentListResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: AssessmentListResponse) => data;

export const useGetAssessmentList = <M = AssessmentListResponse>({
    filters,
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
}: Props<M>) => {
    const query = useQuery<AssessmentListResponse, Error>(
        ['assessments'],
        () => getAssesmentList(filters),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
